module.exports = __webpack_public_path__ + "static/img/analytics.ff284dc9.svg";